import React from "react";
import {Row} from "react-bootstrap";
import {Col} from "react-bootstrap";
import useTranslationCandidates from "../useTranslationCandidates.js";
import "./CandidateUpdateResume.scss";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import ActionButton from "../../common/widgets/ActionButton.js";
import useErrorModal from "../../common/modals/useErrorModal.js";
import useResumeDropbox from "./useResumeDropbox.js";
import useServerErrorFormatter from "../../common/modals/useServerErrorFormatter.js";

export default function CandidateUpdateResume(props) {
  const { candidate, onClose } = props;

  const { t, loading: tLoading } = useTranslationCandidates();

  const {
    ResumeDropbox,
    ready: dropboxReady,
    errors: dropboxErrors,
  } = useResumeDropbox(candidate, "dropbox");
  useShowLoader(tLoading && !dropboxReady, "CandidateUpdateResume");

  const dropboxErrorMsg = useServerErrorFormatter(dropboxErrors, t("candidates:candidates_details_update_error"));
  const { ErrorModal, show: showErrorModal } = useErrorModal(
      <>
        {dropboxErrorMsg}
      </>
  );

  // Show upload error when an error occurs after upload
  React.useEffect(() => {
    if (dropboxErrors) {
      showErrorModal();
    }
  }, [dropboxErrors, showErrorModal]);

  return (
    <>
      {ErrorModal}
      <Row className="CandidateUpdateResume">
        <Col>{ResumeDropbox}</Col>
      </Row>
      <Row className="CandidateUpdateResume">
        <Col className="form-actions">
          <ActionButton onClick={onClose}>
            {t("candidates:candidates_close_action")}
          </ActionButton>
        </Col>
      </Row>
    </>
  );
}
